/* SOL SUAVE — product page enhancements.
   Colour options become circle swatches (image of that colour + its name underneath),
   and the gallery shows only the media tagged for the selected colour.
   Relies on the shop's media alt-text convention: "#Color_<arabic colour name>". */
(function () {
  function norm(s) {
    return String(s == null ? '' : s)
      .replace(/[ً-ْـ]/g, '')
      .replace(/[أإآ]/g, 'ا')
      .replace(/ى/g, 'ي')
      .replace(/ة/g, 'ه')
      /* couples sets name a pair; the option says "a | b" while the alt text
         often says "a \\ b" — one separator so the two always match */
      .replace(/\s*[|\\\/]\s*/g, ' | ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* Tolerant tag reader: "#Color_x", "Color_x", stray spaces and case all work,
     so one mistyped alt can never switch the whole filter off. */
  var TAG = /^\s*#?\s*colou?r_\s*/i;

  function colourOf(img) {
    var alt = img.getAttribute('alt') || '';
    return TAG.test(alt) ? norm(alt.replace(TAG, '')) : null;
  }

  function thumbUrl(img) {
    var src = img.currentSrc || img.getAttribute('src') || '';
    if (!src) return '';
    if (/[?&]width=/.test(src)) return src.replace(/([?&]width=)\d+/, '$1200');
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=200';
  }

  /* Only the product's own media counts. Recommended-product cards and the
     sticky bar carry the same alt convention, and picking them up made the
     swatch of a colour show another product's photo. */
  function galleryRoots() {
    var roots = [].slice.call(document.querySelectorAll('media-gallery'));
    if (!roots.length) {
      roots = [].slice.call(document.querySelectorAll('.media-gallery, .product-media-container'));
    }
    return roots;
  }

  function galleryImages() {
    var seen = [];
    galleryRoots().forEach(function (root) {
      [].slice.call(root.querySelectorAll('img[alt]')).forEach(function (img) {
        if (seen.indexOf(img) === -1) seen.push(img);
      });
    });
    return seen;
  }

  /* colour -> first image url, used as the swatch face */
  function buildSwatchMap() {
    var map = {};
    galleryImages().forEach(function (img) {
      var c = colourOf(img);
      if (c && !map[c]) map[c] = thumbUrl(img);
    });
    return map;
  }

  function colourFieldsets() {
    return [].slice.call(document.querySelectorAll('fieldset.variant-option')).filter(function (fs) {
      var legend = fs.querySelector('legend');
      return legend && norm(legend.textContent).indexOf('لون') !== -1;
    });
  }

  function selectedColour() {
    var fs = colourFieldsets()[0];
    if (!fs) return null;
    var checked = fs.querySelector('input:checked');
    return checked ? norm(checked.value) : null;
  }

  /* Turn each colour radio into a circle swatch with its name underneath. */
  function paintSwatches() {
    var map = buildSwatchMap();
    colourFieldsets().forEach(function (fs) {
      fs.classList.add('ss-swatches');
      [].slice.call(fs.querySelectorAll('label.variant-option__button-label')).forEach(function (label) {
        var input = label.querySelector('input[type="radio"]');
        if (!input) return;
        var colour = norm(input.value);
        var sw = label.querySelector('.ss-sw');
        if (!sw) {
          sw = document.createElement('span');
          sw.className = 'ss-sw';
          sw.setAttribute('aria-hidden', 'true');
          input.insertAdjacentElement('afterend', sw);
        }
        var url = map[colour];
        if (url) sw.style.backgroundImage = 'url("' + url + '")';

        var checked = input.checked;
        sw.classList.toggle('ss-sw--checked', checked);
        label.classList.toggle('variant-option__button-label--checked', checked);
        if (input.dataset.optionAvailable === 'false') {
          label.setAttribute('data-ss-unavailable', 'true');
        } else {
          label.removeAttribute('data-ss-unavailable');
        }
      });
    });
  }

  /* Show only the media whose alt matches the selected colour. */
  function filterGallery() {
    var colour = selectedColour();
    var imgs = galleryImages();
    if (!colour || !imgs.length) return;

    var matches = imgs.filter(function (img) { return colourOf(img) === colour; });
    /* Untagged media (size charts, feature graphics) stays on show. If the chosen
       colour has no photos of its own that is all the customer sees — never the
       other colours. Only a completely empty gallery falls back to showing all. */
    var keepUntagged = imgs.some(function (img) { return colourOf(img) === null; });
    if (!matches.length && !keepUntagged) colour = null;

    var scrollers = [];
    imgs.forEach(function (img) {
      var host = img.closest(
        'slideshow-slide, [class*="thumbnail"], .product-media-container, .media-gallery__grid > li, li'
      );
      if (!host) return;
      var c = colourOf(img);
      var hide = colour !== null && c !== null && c !== colour;
      if (hide) {
        host.setAttribute('data-ss-hidden', 'true');
      } else {
        host.removeAttribute('data-ss-hidden');
        var sc = host.parentElement;
        if (sc && scrollers.indexOf(sc) === -1) scrollers.push(sc);
      }
    });

    scrollers.forEach(function (sc) {
      if (sc.scrollWidth > sc.clientWidth) sc.scrollLeft = 0;
      if (sc.scrollHeight > sc.clientHeight) sc.scrollTop = 0;
    });
  }

  /* ss-cod.js drops the CTA next to Add to cart, inside the quantity row, so it
     only gets the leftover width. Move it below the row to fill the form. */
  function placeTrigger() {
    [].slice.call(document.querySelectorAll('.ss-cod-trigger')).forEach(function (t) {
      var row = t.closest('.product-form-buttons');
      if (row) row.insertAdjacentElement('afterend', t);
    });
  }

  /* ---- couples sets: pick a colour + size for each robe -------------------
     The shop's colour option holds a pair, e.g. "الفضي | اوف وايت". Shopify caps
     a product at 3 options, and colour x colour x size x size would explode the
     variant count, so the four extra choices ride along as line-item properties. */
  var PAIR = {
    sizesW: [
      'Small ( 45 - 50 KG )', 'Medium ( 50 - 60 KG )', 'Large ( 60 - 70 KG )',
      'X-Large ( 70 - 80 KG )', '2X-Large ( 80 - 90 KG )', '3X-Large ( 90 - 100 KG )',
      '4X-Large ( 100 - 110 KG )'
    ],
    sizesM: [
      'Large ( 60 - 70 KG )', 'X-Large ( 70 - 80 KG )', '2X-Large ( 80 - 90 KG )',
      '3X-Large ( 90 - 100 KG )', '4X-Large ( 100 - 110 KG )'
    ],
    /* swatch fills, eyeballed against each set's photography */
    hex: {
      'الفضي': '#A8A5A1', 'فضي': '#A8A5A1', 'رمادي': '#8E8B88',
      'اوف وايت': '#F1EADE', 'ابيض': '#FFFFFF',
      'احمر': '#7E1F2B', 'نبيتي': '#7E1F2B',
      'كحلي': '#1E2A47', 'ازرق': '#2E4C7E', 'ازرق فاتح': '#A9C6DE',
      'البيج': '#D9C4A3', 'بيج': '#D9C4A3', 'بيج فاتح': '#E6D9C3', 'كشمير': '#C9B9A6',
      'بينك': '#E8B4C4', 'وردي فاتح': '#EFC7D2',
      'اخضر': '#2E7C7A', 'الاخضر': '#2E7C7A', 'اخضر مزرق': '#2E7C7A',
      'اخضر غامق': '#1F5B4E', 'زيتي': '#6B6B45',
      'اسود': '#1A1A1A', 'الموف': '#9B7B93', 'موڤ': '#9B7B93', 'بنفسجي': '#6E4C86',
      'ازرق غامق': '#1B3560', 'بيج داكن': '#BFA484', 'رمادي غامق': '#5E5B58',
      'بطيخي': '#E9736B'
    },
    labels: {
      w: { title: 'البرنص النسائي', colour: 'لون البرنص النسائي', size: 'مقاس البرنص النسائي' },
      m: { title: 'البرنص الرجالي', colour: 'لون البرنص الرجالي', size: 'مقاس البرنص الرجالي' }
    }
  };

  /* assets/ss-palette.js may override any fill; keys are normalised on first use */
  var CUSTOM_HEX = null;
  function hexFor(name) {
    if (!CUSTOM_HEX) {
      CUSTOM_HEX = {};
      var src = window.SS_COLOURS || {};
      Object.keys(src).forEach(function (k) { CUSTOM_HEX[norm(k)] = src[k]; });
    }
    var key = norm(name);
    return CUSTOM_HEX[key] || PAIR.hex[key] || '#D8D2D4';
  }

  /* two colours if the selected option value names a pair, otherwise null */
  function pairColours() {
    var fs = colourFieldsets()[0];
    var checked = fs && fs.querySelector('input:checked');
    if (!checked) return null;
    var parts = checked.value.split(/[|\\\/]/).map(function (s) { return s.trim(); }).filter(Boolean);
    return parts.length === 2 ? parts : null;
  }

  function sizeOptions(list) {
    return ['<option value="">اختاري المقاس</option>'].concat(list.map(function (s) {
      return '<option value="' + s + '">' + s + '</option>';
    })).join('');
  }

  function blockHtml(key, list) {
    var l = PAIR.labels[key];
    return '<div class="ss-pair__block" data-block="' + key + '">' +
      '<div class="ss-pair__title">' + l.title + '</div>' +
      '<div class="ss-pair__controls">' +
        '<div class="ss-pair__field">' +
          '<span class="ss-pair__lab">اللون</span>' +
          '<div class="ss-pair__colors" data-k="' + key + '"></div>' +
        '</div>' +
        '<label class="ss-pair__field">' +
          '<span class="ss-pair__lab">المقاس</span>' +
          '<span class="ss-pair__sel">' +
            '<select data-k="' + key + '">' + sizeOptions(list) + '</select>' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>' +
          '</span>' +
        '</label>' +
      '</div>' +
    '</div>';
  }

  function renderDots(wrap, colours) {
    ['w', 'm'].forEach(function (key) {
      var box = wrap.querySelector('.ss-pair__colors[data-k="' + key + '"]');
      if (!box) return;
      var current = wrap.dataset[key];
      if (colours.indexOf(current) === -1) current = key === 'w' ? colours[0] : colours[1];
      wrap.dataset[key] = current;
      /* Rewriting these buttons is a DOM change, which wakes the MutationObserver,
         which calls apply() again — so an unconditional write rebuilt the swatches
         about thirty times a second and a real finger tap never landed on a button
         that survived the gesture. Only write when something actually differs. */
      var sig = colours.join('~') + '|' + current;
      if (box.dataset.ssSig === sig) return;
      box.dataset.ssSig = sig;
      box.innerHTML = colours.map(function (c) {
        return '<button type="button" class="ss-pair__dot" data-k="' + key + '" data-colour="' + c +
          '" aria-pressed="' + (c === current) + '" title="' + c + '" aria-label="' + c +
          '" style="background:' + hexFor(c) + '"></button>';
      }).join('');
      var name = wrap.querySelector('.ss-pair__name[data-k="' + key + '"]');
      if (name) name.textContent = current;
    });
  }

  function pairForm() {
    return document.querySelector('form.shopify-product-form');
  }

  function setHidden(form, name, value) {
    var el = form.querySelector('input[type="hidden"][data-ss-prop="' + name + '"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.setAttribute('data-ss-prop', name);
      el.name = 'properties[' + name + ']';
      form.appendChild(el);
    }
    el.value = value || '';
  }

  function pairProps() {
    var wrap = document.querySelector('.ss-pair');
    if (!wrap) return null;
    var p = {};
    ['w', 'm'].forEach(function (key) {
      var sel = wrap.querySelector('select[data-k="' + key + '"]');
      p[PAIR.labels[key].colour] = wrap.dataset[key] || '';
      p[PAIR.labels[key].size] = sel ? sel.value : '';
    });
    return p;
  }

  function syncPairHidden() {
    var form = pairForm();
    var props = pairProps();
    if (!form || !props) return;
    Object.keys(props).forEach(function (k) { setHidden(form, k, props[k]); });
  }

  function pairValid() {
    var wrap = document.querySelector('.ss-pair');
    if (!wrap) return true;
    var ok = true;
    ['w', 'm'].forEach(function (key) {
      var sel = wrap.querySelector('select[data-k="' + key + '"]');
      var block = wrap.querySelector('.ss-pair__block[data-block="' + key + '"]');
      var missing = sel && !sel.value;
      if (missing) ok = false;
      if (block) block.classList.toggle('ss-pair__block--err', !!missing);
    });
    var err = wrap.querySelector('.ss-pair__err');
    if (err) err.hidden = ok;
    return ok;
  }

  function buildPair() {
    var form = pairForm();
    var vp = document.querySelector('variant-picker');
    var colours = form && vp ? pairColours() : null;
    var wrap = document.querySelector('.ss-pair');

    if (!colours) {
      if (wrap) wrap.remove();
      return;
    }
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'ss-pair';
      wrap.setAttribute('dir', 'rtl');
      wrap.innerHTML = blockHtml('w', PAIR.sizesW) + blockHtml('m', PAIR.sizesM) +
        '<p class="ss-pair__err" hidden>من فضلك اختاري مقاس البرنصين قبل إتمام الطلب.</p>';
      vp.insertAdjacentElement('afterend', wrap);
      wrap.addEventListener('click', function (e) {
        var dot = e.target.closest('.ss-pair__dot');
        if (!dot) return;
        wrap.dataset[dot.dataset.k] = dot.dataset.colour;
        renderDots(wrap, pairColours() || []);
        syncPairHidden();
      });
      wrap.addEventListener('change', function () {
        pairValid();
        syncPairHidden();
      });
    }
    renderDots(wrap, colours);
    syncPairHidden();
  }

  /* Cart drawer / cart page: offer the COD form next to Shopify's own checkout. */
  function closeDrawer(el) {
    var dlg = el.closest('dialog');
    if (dlg && typeof dlg.close === 'function') {
      try { dlg.close(); return; } catch (e) {}
    }
    var drawer = el.closest('theme-drawer, cart-drawer, [class*="drawer"]');
    var closer = drawer && drawer.querySelector('button[aria-label*="Close"], button[aria-label*="إغلاق"], .drawer__close');
    if (closer) closer.click();
  }

  function injectCartTrigger() {
    [].slice.call(document.querySelectorAll('button[name="checkout"], .cart__checkout-button')).forEach(function (btn) {
      var host = btn.closest('.cart__ctas') || btn.parentElement;
      if (!host || host.querySelector('.ss-cart-cod')) return;
      var t = document.createElement('button');
      t.type = 'button';
      t.className = 'ss-cod-trigger ss-cart-cod';
      t.textContent = 'إتمام الطلب';
      t.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer(t);
        if (window.SSCOD && window.SSCOD.open) window.SSCOD.open();
      });
      btn.insertAdjacentElement('beforebegin', t);
    });
  }

  var pending = null;
  var applying = false;
  function apply() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      applying = true;
      paintSwatches();
      buildPair();
      placeTrigger();
      injectCartTrigger();
      filterGallery();
      /* observer callbacks are microtasks, so they run before this timeout and
         see applying === true; anything we just wrote is ignored */
      setTimeout(function () { applying = false; }, 0);
    }, 60);
  }

  /* Add to cart ourselves when the set needs line-item properties, so the two
     robes' colour and size travel with the line no matter which button was used. */
  function addPairToCart() {
    var form = pairForm();
    var idInput = form && form.querySelector('[name="id"]');
    var qtyInput = form && form.querySelector('[name="quantity"]');
    if (!idInput) return Promise.resolve();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(idInput.value),
          quantity: qtyInput && qtyInput.value ? Number(qtyInput.value) : 1,
          properties: pairProps() || {}
        }]
      })
    }).catch(function () {});
  }

  function guardPairButtons(e) {
    var btn = e.target.closest && e.target.closest('.add-to-cart-button, .ss-cod-trigger');
    if (!btn || btn.classList.contains('ss-cart-cod')) return;
    var wrap = document.querySelector('.ss-pair');
    if (!wrap) return;

    if (!pairValid()) {
      e.preventDefault();
      e.stopPropagation();
      try { wrap.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (err) {}
      return;
    }
    syncPairHidden();

    if (btn.classList.contains('ss-cod-trigger')) {
      e.preventDefault();
      e.stopPropagation();
      addPairToCart().then(function () {
        if (window.SSCOD && window.SSCOD.open) window.SSCOD.open();
      });
    }
  }

  function init() {
    apply();
    document.addEventListener('click', guardPairButtons, true);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) apply();
    });
    document.addEventListener('shopify:section:load', apply);
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (applying) return;
        apply();
      }).observe(document.body, { childList: true, subtree: true });
    }
    window.SSProduct = { refresh: apply };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
